import React, { Component } from "react";
import { Form, Input } from "antd";
import {nextStep} from '../redux/actions/miscActions'
import { saveTaxCalcInput } from '../redux/actions/formActions'
import { connect } from "react-redux";

export class TaxCalculations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forfait: '',
      taxFreeSum: '',
      heffingskorting: '',
      sc1min: "",
      sc1max: "",
      sc1per: "",
      sc2min: "",
      sc2max: "",
      sc2per: "",
      sc3min: "",
      sc3max: "",
      sc3per: "",
      sc4min: "",
      sc4max: "",
      sc4per: "",
      sc5min: "",
      sc5max: "",
      sc5per: "",
      schalen: [],
    };
  }

  handleInput = (e) => {
    if(e.target.value.match(/^[0-9]+([0-9.]{1,3})?$/gm)){

      this.setState({
        // [e.target.name]: parseFloat(e.target.value)
        [e.target.name]: e.target.value
      })
    } else if (e.target.value.length === 0) {
      this.setState({
        [e.target.name]: "",
      });
    }
  };

  componentDidMount=()=>{
    const { taxCalcData } = this.props.formData
    this.setState({
      ...taxCalcData
    })
  }

  handleClick=()=>{
    const {
      forfait,
      taxFreeSum,
      heffingskorting,
      sc1min,
      sc1max,
      sc1per,
      sc2min,
      sc2max,
      sc2per,
      sc3min,
      sc3max,
      sc3per,
      sc4min,
      sc4max,
      sc4per,
      sc5min,
      sc5max,
      sc5per,
    } = this.state;
    const taxCalcData = {
      forfait,
      taxFreeSum,
      heffingskorting,
      sc1min,
      sc1max,
      sc1per,
      sc2min,
      sc2max,
      sc2per,
      sc3min,
      sc3max,
      sc3per,
      sc4min,
      sc4max,
      sc4per,
      sc5min,
sc5max,
sc5per,
    }
    this.props.saveTaxCalcInput(taxCalcData)
    this.props.nextStep()
  }

  render() {
    const {
      forfait,
      taxFreeSum,
      heffingskorting,
      sc1min,
      sc1max,
      sc1per,
      sc2min,
      sc2max,
      sc2per,
      sc3min,
      sc3max,
      sc3per,
      sc4min,
      sc4max,
      sc4per,
      sc5min,
sc5max,
sc5per,
    } = this.state;
    return (
      <div className="tax-calculations">
        <div className="form">
          <Form layout="vertical">
            <div className="normal-input">

            <Form.Item label="Forfait">
              <Input
                name="forfait"
                onChange={this.handleInput}
                value={forfait}
                addonAfter={<i className="fas fa-percentage"></i>}
                />
            </Form.Item>

            <Form.Item label="Tax free Sum">
              <Input
                name="taxFreeSum"
                onChange={this.handleInput}
                value={taxFreeSum}
                addonBefore={<i className="fas fa-dollar-sign"></i>}
              />
            </Form.Item>

            <Form.Item label="Heffingskorting">
              <Input
                name="heffingskorting"
                onChange={this.handleInput}
                value={heffingskorting}
                addonBefore={<i className="fas fa-dollar-sign"></i>}
                />
            </Form.Item>
                  </div>

            <div className="schalen-form">
              <div className="schalen-row">
                <p>Scale 1</p>
                <Form.Item label="Minimum">
                  <Input
                    name="sc1min"
                    onChange={this.handleInput}
                    value={sc1min}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                    />
                </Form.Item>
                <Form.Item label="Maximum">
                  <Input
                    name="sc1max"
                    onChange={this.handleInput}
                    value={sc1max}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Percentage">
                  <Input
                    name="sc1per"
                    onChange={this.handleInput}
                    value={sc1per}
                    addonAfter={<i className="fas fa-percentage"></i>}
                  />
                </Form.Item>
              </div>

              <div className="schalen-row">
                <p>Scale 2</p>
                <Form.Item label="Minimum">
                  <Input
                    name="sc2min"
                    onChange={this.handleInput}
                    value={sc2min}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Maximum">
                  <Input
                    name="sc2max"
                    onChange={this.handleInput}
                    value={sc2max}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Percentage">
                  <Input
                    name="sc2per"
                    onChange={this.handleInput}
                    value={sc2per}
                    addonAfter={<i className="fas fa-percentage"></i>}
                  />
                </Form.Item>
              </div>

              <div className="schalen-row">
                <p>Scale 3</p>
                <Form.Item label="Minimum">
                  <Input
                    name="sc3min"
                    onChange={this.handleInput}
                    value={sc3min}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Maximum">
                  <Input
                    name="sc3max"
                    onChange={this.handleInput}
                    value={sc3max}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Percentage">
                  <Input
                    name="sc3per"
                    onChange={this.handleInput}
                    value={sc3per}
                    addonAfter={<i className="fas fa-percentage"></i>}
                  />
                </Form.Item>
              </div>

              <div className="schalen-row">
                <p>Scale 4</p>
                <Form.Item label="Minimum">
                  <Input
                    name="sc4min"
                    onChange={this.handleInput}
                    value={sc4min}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Maximum">
                  <Input
                    name="sc4max"
                    onChange={this.handleInput}
                    value={sc4max}
                    addonBefore={<i className="fas fa-dollar-sign"></i>} 
                  />
                </Form.Item>
                <Form.Item label="Percentage">
                  <Input
                    name="sc4per"
                    onChange={this.handleInput}
                    value={sc4per}
                    addonAfter={<i className="fas fa-percentage"></i>}
                  />
                </Form.Item>
              </div>
             
              <div className="schalen-row">
                <p>Scale 5</p>
                <Form.Item label="Minimum">
                  <Input
                    name="sc5min"
                    onChange={this.handleInput}
                    value={sc5min}
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                  />
                </Form.Item>
                <Form.Item label="Maximum">
                  <Input
                    name="sc5max"
                    onChange={this.handleInput}
                    value="INF"
                    addonBefore={<i className="fas fa-dollar-sign"></i>}
                    disabled 
                  />
                </Form.Item>
                <Form.Item label="Percentage">
                  <Input
                    name="sc4per"
                    onChange={this.handleInput}
                    value={sc5per}
                    addonAfter={<i className="fas fa-percentage"></i>}
                  />
                </Form.Item>
              </div>

            </div>
          </Form>
        </div>
        <div className="buttons">
          <button className="next-button" onClick={this.handleClick}>Next <i className="fas fa-angle-right"></i> </button>
        </div>
      </div>
    );
  }
}
const mapStateToProps=(state)=>({
  formData: state.formData
})

export default connect(mapStateToProps, {nextStep, saveTaxCalcInput})(TaxCalculations);
